import React from "react";
import FilterList from "../../../components/user/movement/movementFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const OrderListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

OrderListPage.propTypes = {};

export default OrderListPage;
